import Swiper from "swiper";

const state = {
  components: [],
  elements: {},
  swipersUpdated: false,
}

const cacheState = () => {
  const sections = Array.from(document.querySelectorAll('[data-section="hub-slideshow"]'));
  state.components = sections.reduce((components, section) => {
    const currentComponent = {
      id: section.dataset.overlayId,
      bodySlider: { 
        el: section.querySelector('.hub-slideshow__body'),
        navigation: section.querySelector('.hub-slideshow__body .hub-slideshow__navigation'),
      },
      footerSlider: {
        el: section.querySelector('.hub-slideshow__footer'),
        navigation: section.querySelector('.hub-slideshow__footer .hub-slideshow__navigation')
      },
    }
    return [...components, currentComponent]
  },[])

  state.elements = {
    learnMoreBtns: document.querySelectorAll('[data-component="learn-more-cta"]')
  }
}

const addEventListeners = () => {
  document.addEventListener('overlay:open', updateSwiperOnShow)

  state.components.forEach(component => {
    if (!component.footerSlider.el) return;
    component.bodySlider.el.addEventListener('click', onSlideClicked.bind(component))
  })
}

const updateSwiperOnShow = (e) => {
  const componentsToUpdate = state.components.filter(component => component.id === e.detail.id);

  componentsToUpdate.forEach(component => {
    component.bodySlider.swiper?.update();
    component.footerSlider?.swiper?.update();
    component.footerSlider?.el?.classList.add('tablet-hidden')
    component.bodySlider.el.classList.add("swiper-untouched");

    state.swipersUpdated = true
  })
}

const initSwiper = () => {
  state.components.forEach(component => {
    component.bodySlider.swiper = new Swiper(component.bodySlider.el, {
      breakpoints: {
        1800: {
          slidesPerView: 4.3,
        },
        1025: {
          slidesPerView: 3.3,
        },
        600: {
          slidesPerView: 2.6,
        }
      },
      slidesPerView: component.footerSlider.el ? 1.1 : 1.4,
      spaceBetween: 10,
      loop: true,
      centeredSlides: false,
      slideToClickedSlide: true,
      navigation: {
        nextEl: '.hub-slideshow__navigation--next',
        prevEl: '.hub-slideshow__navigation--prev'
      },
      on: {
        slideChange: (swiper) => {
          if (!state.swipersUpdated) return;
          component.footerSlider.swiper?.slideTo(swiper.realIndex);
        }
      }
    })
    component.bodySlider.navigation.addEventListener('click', onNavClick.bind(component, ["footerSlider", "bodySlider"]))
    if (!component.footerSlider.el) return;
    component.footerSlider.swiper = new Swiper(component.footerSlider.el, {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: false,
      allowTouchMove: false,
    })
    component.footerSlider.navigation.addEventListener('click', onNavClick.bind(component, ["footerSlider", "bodySlider"]))
  })
}

function onNavClick (sliders=[], e) {
  const action = e.target.closest('button')?.dataset.action;
  sliders.forEach(slider => {
    this[slider]?.swiper?.[action]();
  })
}

function onSlideClicked (e) {
  e.preventDefault();
  const clickedSlide = e.target.closest(".hub-slideshow__item");
  const targetIndex = clickedSlide?.dataset.swiperSlideIndex;
  if (!targetIndex) return;

  this.footerSlider.el.classList.remove("tablet-hidden");
  this.bodySlider.el.classList.remove("swiper-untouched");
  this.footerSlider.swiper.slideTo(targetIndex, 400);
  setTimeout(() => {
    this.footerSlider.el.scrollIntoView({behavior: "smooth", block: "start", inline: "start"})
  }, 400)
}

const init = () => {
  cacheState();
  initSwiper();
  addEventListeners();
}

export default init;